<template>
  <b-overlay :show="false" rounded="sm" variant="white">
    <b-card id="summary-card">
      <!-- DETAILS -->
      <b-row>
        <b-col cols="12" class="mb-1">
          <h6 class="mb-25">Nom complet</h6>
          <div class="d-flex" v-if="editMode">
            <b-form-input v-model="editedDetails.firstName" placeholder="Nom" />
            <b-form-input
              v-model="editedDetails.lastName"
              placeholder="Llinatges"
            />
          </div>
          <b-card-text v-else>{{ fullName }}</b-card-text>
        </b-col>
        <b-col cols="12" class="mb-1">
          <h6 class="mb-25">Telèfon</h6>
          <b-form-input v-if="editMode" v-model="editedDetails.phone" />
          <b-card-text v-else>{{ phone }}</b-card-text>
        </b-col>
        <b-col cols="12" class="mb-1">
          <h6 class="mb-25">Correu electrònic</h6>
          <b-form-input v-if="editMode" v-model="editedDetails.email" />
          <b-card-text v-else>{{ email }}</b-card-text>
        </b-col>
      </b-row>

      <!-- BUTTONS -->
      <b-row class="d-flex justify-content-between justify-content-sm-end">
        <b-col v-if="editMode" cols="6" sm="auto">
          <b-button block variant="light" @click="editMode = false">
            Cancel·la
          </b-button>
        </b-col>
        <b-col v-if="editMode" cols="6" sm="auto">
          <b-button block variant="primary" @click="onSaveButtonClicked">
            Guarda
          </b-button>
        </b-col>
        <b-col v-if="!editMode" cols="12" sm="auto">
          <b-button block variant="primary" @click="onEditButtonClicked">
            Edita
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BCard,
  BCardText,
  BRow,
  BCol,
  BButton,
  BFormInput,
} from "bootstrap-vue";
import { notifyError, notifySuccess } from "@/utils/methods";

export default {
  components: {
    BOverlay,
    BCard,
    BCardText,
    BRow,
    BCol,
    BButton,
    BFormInput,
  },
  data() {
    return {
      editMode: false,
      editedDetails: {
        firstName: null,
        lastName: null,
        phone: null,
        email: null,
      },
    };
  },
  computed: {
    provider() {
      return this.$store.getters["provider/provider"];
    },
    fullName() {
      return this.provider?.fullName || this.$t("No disponible");
    },
    phone() {
      return this.provider?.phone || this.$t("No disponible");
    },
    email() {
      return this.provider?.email || this.$t("No disponible");
    },
  },
  watch: {
    editMode(value) {
      if (value) {
        this.initInputs();
      }
    },
  },
  methods: {
    initInputs() {
      this.editedDetails = {
        firstName: this.provider?.firstName || null,
        lastName: this.provider?.lastName || null,
        phone: this.provider?.phone || null,
        email: this.provider?.email || null,
      };
    },
    onEditButtonClicked() {
      this.editMode = true;
    },
    onSaveButtonClicked() {
      this.$store.dispatch("app/setLoading", true);

      this.$store
        .dispatch("provider/updateProvider", {
          uuid: this.provider?.uuid,
          ...this.editedDetails,
        })
        .then(() => {
          notifySuccess(
            "Proveïdor actualitzat",
            "El proveïdor s'ha actualitzat correctament"
          );
          this.editMode = false;
        })
        .catch(() =>
          notifyError(
            "Detalls no actualitzats",
            "El proveïdor no s'ha pogut actualitzar correctament, si us plau, revisa les dades introduïdes"
          )
        )
        .finally(() => this.$store.dispatch("app/setLoading", false));
    },
  },
};
</script>
